import React from 'react'
import cx from 'classnames'
import { faSpinner } from '@fortawesome/pro-duotone-svg-icons/faSpinner'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Icon from '@softwaredev_cegeka/stix-core/dist/components/Icon'
import styles from './loader.module.scss'

export default function Loader({ inline, className, children, ...rest }) {
    return (
        <div
            role={'status'}
            className={cx(styles.loadingOverlay, className)}
            {...rest}
        >
            <div className="d-flex">
                <Icon
                    icon="loading"
                    className={cx(
                        'animate-spin',
                        { 'icon-inline': inline },
                        className
                    )}
                />
            </div>
            {children}
        </div>
    )
}

export function RouteLoader() {
    return <Loader className={styles.routeLoader} aria-label={'routeLoader'} />
}

export function NavLoader() {
    return (
        <div className="vert-nav-link">
            <Loader />
        </div>
    )
}

export const AnimatedSpinner = ({ className }) => {
    return (
        <div
            role={'status'}
            aria-label={'Loading data...'}
            className={cx(styles.animatedSpinner, className)}
        >
            <FontAwesomeIcon icon={faSpinner} pulse={true} />
        </div>
    )
}
